import { Routes } from '@angular/router';
import { Authority } from '@app/shared/utils/enums';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { FortigateProvisioningComponent } from './fortigate-provisioning.component';

export const fortigateProvisioningRoutes: Routes = [
    {
        path: 'fortigate-provisioning',
        children: [
            {
                path: '',
                component: FortigateProvisioningComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.UPDATE, Authority.INTL]
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]